import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	atlassianIntelligenceInformation: {
		id: 'atlassian-intelligence.common.ai-information-icon.atlassian-intelligence-information',
		defaultMessage:
			'The quality, accuracy, and reliability of information generated by Atlassian Intelligence may vary. <link>Learn more</link>',
		description: 'Tooltip text with a description of the AI generated answers',
	},
});
